var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('b-container',{staticClass:"p-0",attrs:{"fluid":""}},[_c('Header'),_c('b-container',{staticClass:"main-container pl-5 pr-5 flex-grow-1",attrs:{"fluid":""}},[_c('router-view')],1),_c('b-container',{staticClass:"pl-5 pr-5",attrs:{"fluid":""}},[_c('Footer')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }